import {Box, Button, styled, TableCell, TableRow} from '@mui/material';
import React from 'react';
import SessionInfo from '../shared/SessionInfo';
import styles from '../../styles';
import SessionTileStat from '../shared/SessionTileStat';
import {getTime} from '../../services/dateService';
import {useTranslation} from 'react-i18next';
import {PlayerSession} from '../../interfaces';
import {NavLink, useLocation} from 'react-router-dom';
import {getIntensityText} from '../../services/playerSessionService';
import {SessionTypes} from '../../enums';

const TableCellWrapper = styled(TableCell)(({theme}) => ({
  [theme.breakpoints.down('md')]: {
    display: 'block',
    border: 'none',
  },
  [theme.breakpoints.up('md')]: {
    display: 'table-cell',
  },
}));

interface Props {
  session: PlayerSession;
  teamId: number;
  profileId?: number;
  familyId?: number;
  sessionTag?: string;
}

const SessionListItem: React.FC<Props> = ({
  session,
  teamId,
  profileId,
  familyId,
  sessionTag,
}) => {
  const {t} = useTranslation();
  const location = useLocation();
  const hash = location.hash;
  const {
    id,
    type,
    startTime,
    endTime,
    activeTime,
    timeOnIce,
    hustleScore,
    points,
    strideCountLeft,
    strideCountRight,
    teamSessionId,
    localDisplayStartTime,
    sessionDetail,
    timeZone,
  } = session;
  const strideCount = (strideCountLeft || 0) + (strideCountRight || 0);
  let navigateUrl = `/teams/${teamId}/teamSessions/${teamSessionId}/playersessions/${id}${hash}`;
  if (familyId && profileId) {
    navigateUrl = `/family/children/${profileId}/playersessions/${id}`;
  } else if (profileId) {
    navigateUrl = `/teams/${teamId}/players/${profileId}/playersessions/${id}`;
  }
  const typeText = `${type || ''}${type && sessionTag ? ' - ' : ''}${sessionTag || ''}`;
  return (
    <TableRow
      sx={{
        borderBottom: {xs: '1px solid rgb(81, 81, 81)', md: 'none'},
      }}>
      <TableCellWrapper>
        <SessionInfo
          sxTitleAndLengthBox={{
            display: {xs: 'flex', md: 'block'},
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
          type={typeText}
          startTime={startTime ? new Date(startTime) : undefined}
          endTime={endTime ? new Date(endTime) : undefined}
          localDisplayStartTime={localDisplayStartTime}
          sessionDetail={sessionDetail}
          timezone={timeZone}
        />
      </TableCellWrapper>
      <TableCellWrapper>
        <Box sx={{...styles.flexDirectionRow}}>
          <SessionTileStat
            label={
              t(
                type === SessionTypes.game
                  ? 'sessionStats.timeOnIce'
                  : 'sessionStats.activeTime',
              ) as string
            }
            value={
              getTime(type === SessionTypes.game ? timeOnIce : activeTime) ??
              '--'
            }
          />
          <SessionTileStat
            label={t('sessionStats.strides') as string}
            value={strideCount ?? '--'}
          />
          <SessionTileStat
            label={t('sessionStats.hustle') as string}
            value={
              hustleScore ? getIntensityText(hustleScore).toUpperCase() : '--'
            }
          />
          <SessionTileStat
            label={t('sessionStats.points') as string}
            value={points ?? '--'}
          />
        </Box>
      </TableCellWrapper>
      <TableCellWrapper align="right">
        <Button component={NavLink} to={navigateUrl}>
          {t('general.details')}
        </Button>
      </TableCellWrapper>
    </TableRow>
  );
};

export default SessionListItem;
